import 'promise-polyfill/src/polyfill'
import './polyfills'
import 'intersection-observer'

import './assets'

import { createComponent } from '@bigyouth/base'

/* eslint-disable-next-line */
import whatInput from 'what-input' // accessibility focus
import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks' // lazyload bgs with data-bg

import './style/styles-global.scss'
import * as features from './features/exports/global'

Object.values(features).forEach(createComponent)

// remove preload class on body (prevent flash of transitions when page is loading)
document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('preload')
})

if (sessionStorage.getItem('currentUrl') === null || (!sessionStorage.getItem('currentUrl').includes(window.location.href) && sessionStorage.getItem('currentUrl') !== window.location.href.split('?')[0]) || window.location.pathname === '/' || window.location.pathname === '/en') {
  sessionStorage.setItem('prevUrl', sessionStorage.getItem('currentUrl'))
  sessionStorage.setItem('currentUrl', window.location.href.split('?')[0])

  sessionStorage.setItem('prevUrlIsMap', sessionStorage.getItem('currentUrlIsMap'))
  sessionStorage.setItem('currentUrlIsMap', document.querySelector('[js-projects-map]') !== null)
}
